export default [
    {
        path: '',
        name: 'lvkeyun',
        meta: {
            title: '购买确认'
        },
        component: () => import('@/views/lvkeyun/index.vue')
    },
    {
        path: 'payResult',
        name: 'lvkeyunResult',
        meta: {
            title: '支付'
        },
        component: () => import('@/views/lvkeyun/payResult.vue')
    }
]
